export enum RouteName {
  List = 'invoice-list',
}
